






















































































































































































































































































































import { computed, defineComponent } from '@vue/composition-api';

export default defineComponent({
  name: 'PowerConsumptionTable',
  props: {
    powerConsumptions: {
      type: Array,
      required: true,
    },
  },
  setup: (props) => {
    const consumptionNorm = computed(() => props.powerConsumptions
      .map((fc: any) => fc.norm)
      .reduce((a, b) => a + b, 0));

    const actualConsumption = computed(() => props.powerConsumptions
      .map((fc: any) => fc.consumptionSummary)
      .reduce((a, b) => a + b, 0));

    return {
      consumptionNorm,
      actualConsumption,
    };
  },
});
